'use client';

import { useEffect } from 'react';

const MIN_LAYOUT_WIDTH = 800;

/**
 * Ensures the editor always renders at ≥800px layout width:
 * - Mobile devices: viewport meta `width=800` → browser scales natively
 * - Desktop small windows: CSS zoom on <html> to shrink the 800px layout into the window
 */
export function ViewportManager() {
  useEffect(() => {
    // Detect if this is likely a mobile/touch device
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      ('ontouchstart' in window && window.innerWidth < 900);

    // Set viewport meta for mobile devices
    let meta = document.querySelector('meta[name="viewport"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'viewport');
      document.head.appendChild(meta);
    }

    if (isMobile) {
      meta.setAttribute('content', `width=${MIN_LAYOUT_WIDTH}`);
    } else {
      meta.setAttribute('content', 'width=device-width, initial-scale=1');
    }

    // For desktop: use CSS zoom when window is too narrow
    function applyZoom() {
      if (isMobile) return; // mobile uses viewport meta instead
      const w = window.innerWidth;
      if (w < MIN_LAYOUT_WIDTH) {
        document.documentElement.style.zoom = `${w / MIN_LAYOUT_WIDTH}`;
      } else {
        document.documentElement.style.zoom = '';
      }
    }

    applyZoom();
    window.addEventListener('resize', applyZoom);
    return () => window.removeEventListener('resize', applyZoom);
  }, []);

  return null;
}
